import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModelserviceService } from 'src/app/modelservice.service';
import { popup } from 'src/app/popup';

import { UserserviceService } from 'src/app/userservice.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
    loginForm!: FormGroup;
    islogin: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private auth: UserserviceService,
        private openModel: ModelserviceService
    ) {
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
        });
    }
    passwordVisible: boolean = false;

    togglePasswordVisibility() {
        this.passwordVisible = !this.passwordVisible;
    }
    ngOnInit() {
        localStorage.clear();
    }

    popup!: popup;
    open() {
        console.log('open');

        this.popup = {
            header: 'Unable to Sign In',
            mainContent:
                'We couldn’t verify your email or password. Please try again.',
            leftButton: '',
            rightButton: 'Ok',
        };
        this.openModel.openModel(this.popup);
    }

    async loginUser() {
        this.islogin = true;
        try {
            if (this.loginForm.valid) {
                const result = await this.auth.emailSignIn(
                    this.loginForm.value
                );
                if (result == true) {
                    console.log('login successfully');
                } else {
                    this.open();
                }
            } else {
                this.loginForm.markAllAsTouched();
            }
        } catch (err) {
            console.log(err);
        } finally {
            this.islogin = false;
        }
    }
}
